import React, { useState, useEffect } from "react";
import Button from '../../../../button/button';
import Modal from '../../../../modal/modal';
import './paymentConfirm.scss';
import PrintReceipt from "./PrintReceipt/PrintReceipt";
import Axios from 'axios'
import PaymentMethod from "./paymentMethod/PaymentMethod";
import SplitPay from "./SplitPay/SplitPay";
import Tooltip from "../../../../Tooltip/Tooltip";
import CloseSVG from "../../../../icons/close";
import { dataDecrypt } from "../../../../../utils/dataDecrypt";
import { dataEncrpt } from "../../../../../utils/dataEncrypt";
const PaymentConfirm = (props) => {
    //state to open print receipt
    const [isOpenPrintReceipt, setIsOpenPrintReceipt] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({
        receptionist_id: '',
        receptionist_subsidiary_id: '',
        students_payments: [],
        paymentMethod: [],
        amount_payed: 0,
        exchange_rate: ''
    })
    const [formatPaymentD, setFormatPaymentD] = useState([])
    const [totalAmount, setTotalAmount] = useState(0);
    //state to split pay
    const [isSplitPay, setIsSplitPay] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState([])
    const [receiptResultData, setReceiptResultData] = useState({})
    const [isSplitRemaining, setIsSplitRemaining] = useState(false)
    const [buttonFinishPayment, setButtonFinishPayment] = useState(false)
    const subsidiaryToRegisterPaid = localStorage.getItem('receptionSubsidiarySession')
    useEffect(() => {
        if (props.isOpen) {
            setPaymentDetails(prev => ({
                ...prev, students_payments: props.concepts,
                receptionist_id: props.usr.employee_id,
                receptionist_subsidiary_id: subsidiaryToRegisterPaid,
                paymentMethod: paymentMethod,
                exchange_rate: props.exchange

            }))
        }
    }, [paymentMethod])

    useEffect(() => {
        if (paymentDetails.students_payments.length > 0) {
            let concepts = paymentDetails.students_payments;
            const formattedData = concepts.map(student => (
                {
                    id: student.id_student,
                    name: student.name,
                    concepts: [
                        // Formateo de tuition si no está vacío
                        ...(student.concepts_to_pay.tuition && student.concepts_to_pay.tuition.length > 0 ? student.concepts_to_pay.tuition.map(t => ({
                            name: t.isTuition ? "Colegiatura" : "Abono",
                            amount: t.amount && !isNaN(t.amount) ? t.amount.toFixed(2) : "0.00", // Asegúrate de que sea un número válido
                        })) : []),

                        // Formateo de books si no está vacío
                        ...(student.concepts_to_pay.books && student.concepts_to_pay.books.length > 0 ? student.concepts_to_pay.books.map(b => ({
                            name: `${b.name}`,
                            amount: b.price && !isNaN(b.price) ? b.price.toFixed(2) : "0.00", // Asegúrate de que sea un número válido
                        })) : []),

                        // Formateo de inscription si no está vacío
                        ...(student.concepts_to_pay.inscription && typeof student.concepts_to_pay.inscription.amount === "number" ? [{
                            name: "Inscripción",
                            amount: !isNaN(student.concepts_to_pay.inscription.amount) ? student.concepts_to_pay.inscription.amount.toFixed(2) : "0.00",
                        }] : []),
                    ]
                }));


            // Actualizamos el estado con los datos formateados
            setFormatPaymentD(formattedData);
            // Calculate the total amount to pay (in MXN)
            // Calculamos el total a partir de los conceptos de cada alumno
            const computedTotal = formattedData.reduce((total, student) => {
                const studentTotal = student.concepts.reduce((sum, concept) => {
                    return sum + parseFloat(concept.amount);
                }, 0);
                return total + studentTotal;
            }, 0);

            setTotalAmount(computedTotal);
        }
    }, [paymentDetails]);



    // Total amount in dollars (for display only)
    const dllsChange = props.exchange ? (totalAmount / props.exchange).toFixed(2) : "0.00";

    const handleConfirmPayment = async () => {
        setButtonFinishPayment(true)
        // Función para mostrar alertas
        const showAlert = (msg, type) => {
            const id = Math.floor(Math.random() * 100) + 1;
            props.setArrayAlerts(oldArray => [{ id, message: msg, type }, ...oldArray]);
            props.setIsVisibleAlert(true);
        };
        if (paymentMethod.length > 1) {
            if (isSplitRemaining) {
                setButtonFinishPayment(false)
                return showAlert("Verifique que la cantidad a pagar sea la correcta", 'info');
            }
            // Verifica si hay efectivo MXN para dar cambio
            const hasZeroMethodPaymentAmount = paymentMethod.some(
                (m) => m.amount === '' || m.amount === '0.00' || m.amount === 0
            );
            if (hasZeroMethodPaymentAmount) {
                setButtonFinishPayment(false)
                return showAlert("Verifique nuevamente las cantidades de los metodos de pago, no puedo haber 0", 'danger');
            }
        } else {
            if (paymentMethod.length > 0) {
                let method = paymentMethod[0]
                if ('rawAmount' in method) {
                    if (method.amount === '' || method.amount === '0.00' || method.amount === 0) {
                        setButtonFinishPayment(false)
                        return showAlert("Verifique nuevamente las cantidades de los metodos de pago", 'danger');
                    }
                    if (paymentMethod.length === 1) {
                        setButtonFinishPayment(false)
                        return showAlert("Presione el boton <- regresar si desea solamente utilizar 1 solo metodo de pago", 'danger');
                    }
                }
            }
        }
        let arrayToPay = paymentDetails;
        const newobj={
            ...arrayToPay,
            students_payments:paymentDetails.students_payments.map(({paymentHistory, inscription_date, id_student_section, inactive_weeks, paused_weeks, ...rest}) => rest)
        }
        const postResponseRegisterStudentsPayment = await PostRegisterStudentsPayment(newobj);
        if (postResponseRegisterStudentsPayment && postResponseRegisterStudentsPayment.status) {
            const { status, message } = postResponseRegisterStudentsPayment;



            const infoStatuses = [201, 202, 203, 204, 205, 206, 207, 208, 210, 211, 212];
            switch (status) {
                case 200:
                    let receiptId = postResponseRegisterStudentsPayment.result.receipt_id;
                    const receiptResult = await GetPaymentReceiptByID(receiptId)
                    let statusR = receiptResult.status
                    switch (statusR) {
                        case 200:
                            // 🔹 aquí hacemos el merge con props.concepts
                            const mergedResult = {
                                ...receiptResult.result,
                                students: receiptResult.result.students.map(student => {
                                    const match = props.concepts.find(c => c.id_student === student.id);
                                    if (match) {
                                        return {
                                            ...student,
                                            full_class_name: match.full_class_name
                                        };
                                    }
                                    return student;
                                })
                            };
                            setReceiptResultData(mergedResult)
                            setIsOpenPrintReceipt(true);
                            showAlert(message, 'success');
                            updateCashAuditTotal(mergedResult.payment_methods, props.exchange)
                            break;

                        default:
                            break;
                    }
                    break;
                case 209:
                    setButtonFinishPayment(false)
                    showAlert(message, 'danger');
                    break;

                default:
                    if (infoStatuses.includes(status)) {
                        setButtonFinishPayment(false)
                        showAlert(message, 'info');
                    }
                    break;
            }
        }
    };

    const updateCashAuditTotal = (paymentMethods, excUSD) => {
        const LIMIT = 4500;

        const currentEncrypted = localStorage.getItem('alarmToCashAudit');
        const previousTotal = Number(
            currentEncrypted ? dataDecrypt(currentEncrypted) : 0
        );

        const newCashTotal = paymentMethods.reduce((acc, pm) => {
            if (!pm?.name) return acc;

            const name = pm.name.toLowerCase();
            const safeAmount = Number(pm.amount) || 0;

            if (name.includes('efectivo') && name.includes('mxn')) {
                return acc + safeAmount;
            }

            if (name.includes('efectivo') && name.includes('usd')) {
                return acc + safeAmount * excUSD;
            }

            return acc;
        }, 0);

        const updatedTotal = previousTotal + newCashTotal;

        localStorage.setItem(
            'alarmToCashAudit',
            dataEncrpt(updatedTotal)
        );

        // 🚨 DETECTAR PRIMER CRUCE
        if (previousTotal < LIMIT && updatedTotal >= LIMIT) {
            localStorage.setItem('cashAuditLimitCrossed', 'true');
            localStorage.removeItem('cashAuditLastAlert'); // fuerza alerta inmediata
        }
        // 🔔 AVISAR AL MAIN INMEDIATAMENTE
        window.dispatchEvent(
            new CustomEvent('cash-audit-updated', {
                detail: { total: updatedTotal }
            })
        );
        return updatedTotal;
    };



    const GetPaymentReceiptByID = async (receipt_id) => {
        try {
            const res = await Axios.post(
                process.env.REACT_APP_API_URL + "getPaymentReceiptByID/",
                { receipt_id },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error("Error recibiendo recibos de pago:", error);
            return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
        }
    };

    const PostRegisterStudentsPayment = async (payment_detail) => {
        try {
            const res = await Axios.post(
                process.env.REACT_APP_API_URL + "postRegisterStudentsPayment/",
                { payment_detail },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error("Error registrando pagos:", error);
            return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
        }
    };
    const handleClosePrintReceipt = () => {
        setIsOpenPrintReceipt(false);
    }
    const handleSplitPay = () => {
        setIsSplitPay(true);
    }
    const handleCloseSplitPay = () => {
        setIsSplitPay(false);
    }
    const handleCloseModal = () => {
        if (Object.keys(receiptResultData).length !== 0) {
            props.onClose()
            props.cleanFields()
        } else {
            props.onClose()
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    const handleAnotherReceipt = () => {
        props.onClose()
        props.cleanFields()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    return (
        <>
            <Modal isOpen={props.isOpen} onClose={props.onClose} overlayClick={false}>
                <button className="modal-close-button" onClick={handleCloseModal}>
                    <CloseSVG />
                </button>
                <div className='confirm-pay-container'>
                    <div className='confirm-pay'>
                        <div className='summary-container'>
                            <h1 className='title-1'>Resumen de pago</h1>
                            <ul className='summary-list'>
                                {formatPaymentD.map((student) => (
                                    <li key={student.id} className='summary-student-section'>
                                        <div className='summary-student-container'>
                                            <h1 className='title-3'>{student.name}</h1>
                                            <ul>
                                                {student.concepts.map((concept, index) => (
                                                    <li key={index}>
                                                        <p>{concept.name}</p>
                                                        <p>${concept.amount}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <div className='summary-amount'>
                                <p className='amount-mxn'>
                                    Importe total: ${totalAmount.toFixed(2)}
                                </p>
                                <p className='amount-dlls'>
                                    Importe en dolar: ${dllsChange}
                                </p>
                            </div>
                        </div>

                        {/* Payment method section */}
                        <div className="payment-method-container">
                            {!isSplitPay ?
                                <>
                                    <div className="payment-method-container-buttons">
                                        <Tooltip text={'Utiliza esta opción para cobrar el importe con dos o mas métodos de pago'}>
                                            <Button text={'Dividir pago'} onClick={handleSplitPay} />
                                        </Tooltip>
                                        <Tooltip text={'Regresar a la ventana anterior'}>
                                            <Button backgroundColor="red" text={"Realizar otro recibo"} onClick={handleAnotherReceipt} />
                                        </Tooltip>

                                    </div>
                                    <PaymentMethod
                                        totalAmount={totalAmount}
                                        exchange={props.exchange}
                                        setPaymentMethod={setPaymentMethod}
                                    />
                                </> :
                                <>
                                    <div className="payment-method-container-buttons">
                                        <Tooltip text={'Pagar con un solo método de pago'}>
                                            <Button text={'Un solo pago'} onClick={handleCloseSplitPay} />
                                        </Tooltip>
                                        <Tooltip text={'Regresar a la ventana anterior'}>
                                            <Button backgroundColor="red" text={"Realizar otro recibo"} onClick={handleAnotherReceipt} />
                                        </Tooltip>
                                    </div>
                                    <SplitPay
                                        onClose={handleCloseSplitPay}
                                        totalAmount={totalAmount}
                                        exchange={props.exchange}
                                        setPaymentMethod={setPaymentMethod}
                                        stateRemaining={setIsSplitRemaining}
                                    ></SplitPay>
                                </>}
                        </div>

                    </div>
                    <div className='confirm-buttons-section'>
                        <Button backgroundColor="blue" disabled={Object.keys(receiptResultData).length === 0} text="Imprimir Recibo" onClick={() => setIsOpenPrintReceipt(true)} />
                        <Tooltip text={'Regresar a la ventana anterior'}>
                            <Button backgroundColor="red" text={"Atras"} onClick={handleCloseModal} />
                        </Tooltip>
                        <Tooltip text={'Al finalizar el pago no se puede editar o cancelar'}>
                            <Button backgroundColor="blue" disabled={Object.keys(receiptResultData).length !== 0 || buttonFinishPayment} text="Finalizar pago" onClick={handleConfirmPayment} />
                        </Tooltip>
                    </div>
                </div>

            </Modal>
            {isOpenPrintReceipt && <PrintReceipt isOpen={true} onClose={handleClosePrintReceipt} receiptData={receiptResultData} />}

        </>
    );
};

export default PaymentConfirm;